module.exports = __webpack_public_path__ + "static/media/keyword-in-title.a1373bbb.svg";